import React from 'react';
import { Upload, Image as ImageIcon } from 'lucide-react';

const LogoUploadCard = ({ logoPreview, onLogoChange }) => (
  <div className="bg-white rounded-xl shadow p-6">
    <h3 className="font-semibold mb-4">店铺 Logo</h3>
    <div className="flex flex-col items-center space-y-4">
      <div className="w-32 h-32 rounded-full border-4 border-dashed border-gray-300 overflow-hidden flex items-center justify-center bg-gray-50">
        {logoPreview
          ? <img src={logoPreview} alt="Logo" className="w-full h-full object-cover" />
          : <ImageIcon className="w-12 h-12 text-gray-400" />}
      </div>
      <input type="file" id="logoUpload" accept="image/*" onChange={onLogoChange} className="hidden" />
      <label htmlFor="logoUpload"
        className="flex items-center space-x-2 px-4 py-2 bg-gray-100 hover:bg-gray-200 rounded-lg cursor-pointer text-sm">
        <Upload className="w-4 h-4" />
        <span>上传 Logo</span>
      </label>
      <p className="text-xs text-gray-400">建议正方形，最大 5MB</p>
    </div>
  </div>
);

export default LogoUploadCard;